import { create } from 'zustand';

interface AccountHealthState {
  /** How many connected accounts currently need the organizer to reconnect. */
  reconnectCount: number;
}

interface AccountHealthActions {
  setReconnectCount: (count: number) => void;
  reset: () => void;
}

const initialState: AccountHealthState = { reconnectCount: 0 };

/**
 * Credential health, lifted out of the accounts feature so the app chrome can
 * read it. The sidebar lives in shared/components and cannot reach into a
 * feature's queries, so the accounts feature pushes the count here instead
 * (same arrangement as the notifications badge).
 */
export const useAccountHealthStore = create<AccountHealthState & AccountHealthActions>()((set) => ({
  ...initialState,
  setReconnectCount: (reconnectCount) => set({ reconnectCount }),
  reset: () => set(initialState),
}));
